/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * DatePicker types
 * - Header types
 * - Body types
 * - Period types
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import { Moment } from 'moment';

export interface IDatePickerProps {
    maxDate?: Moment;
    minDate?: Moment;
    selectedDay?: Moment;
}

export interface IDatePickerLocale {
    monthNames: string[];
    weekNames: string[];
}

/*
* -------------------------------------------
*          Header Props
* -------------------------------------------
*/

export interface IDatePickerHeaderProps extends IDatePickerProps {
    locale: IDatePickerLocale;
    periodChangeHandler: (newPeriod: Moment) => void;
    period: Moment;
}

/*
* -------------------------------------------
*          Body Props
* -------------------------------------------
*/

export interface IDatePickerBodyProps extends IDatePickerProps {
    onSelectDateHandler: (day: Moment) => void;
    period: Moment;
    periodType: EDatePickerPeriodType;
}

export interface IDatePickerBodyCellProps extends IDatePickerProps {
    className: string;
    day: Moment;
    key: number;
}

/*
* -------------------------------------------
*           Period
* -------------------------------------------
*/

export enum EDatePickerPeriodType {
    DAY = 'DAY',
    MONTH = 'MONTH',
    QUARTER = 'QUARTER',
    YEAR = 'YEAR',
}

/*
* -------------------------------------------
*          Footer Props
* -------------------------------------------
*/

export interface IDatePickerAdditionalButton {
    onClick: () => void;
    title: string;
}
